import { computed, toValue, type ComputedRef, type MaybeRefOrGetter } from "vue";
import type { SortOption, SpeciesSort } from "@carnet/ui/utils/speciesSort";

// `isNaturalist` injecté : le profil est un auto-import propre à chaque app (web-only vs mobile).
export function useAppSpeciesSortOptions(isNaturalist: MaybeRefOrGetter<boolean>): ComputedRef<SortOption<SpeciesSort>[]> {
  const { t } = useI18n();
  return computed(() => {
    const options: SortOption<SpeciesSort>[] = [
      { label: t("ui.sort.popularity_desc"), value: "observations_desc" },
      { label: t("ui.sort.creation_date_desc"), value: "date_desc" },
      { label: t("ui.sort.specie_label_asc"), value: "alpha_asc" },
      { label: t("ui.sort.specie_label_desc"), value: "alpha_desc" },
    ];
    if (toValue(isNaturalist)) {
      options.push({ label: t("ui.sort.taxon_label_asc"), value: "taxon_asc" });
    }
    return options;
  });
}
